export default {
  date: 'June 20, 2024',
  title: 'Update: New style "Modern"',
  description: 'The new interior design attracts buyers to real estate',
  id: 'update-style-modern',
  jsx: () => (
    <div class='novelty__text'>
      <p>We are pleased to introduce our new interior style - "Modern".</p>
      <p>
        This style is characterized by refined, clean, and minimalist design, emphasizing simplicity and elegance.
        <br />
        Key features of "Modern" include:
      </p>
      <b>Neutral palette</b>
      <p>White, gray, and beige tones create an elegant background.</p>
      <b>Clean lines</b>
      <p>Straight lines and streamlined shapes ensure order.</p>
      <b>Minimalism</b>
      <p>Minimal decorations with focus on a few key elements.</p>
      <b>High-quality materials</b>
      <p>Marble countertops, parquet floors, and metal fixtures.</p>
      <p>The "Modern" style is versatile and suitable for a wide audience who values comfort and modern amenities. By selling real estate with this style, you can attract buyers faster and stand out among competitors.</p>
      <p>The new style is already available on our website!</p>
    </div>
  ),
  thumb: 'news/22.webp',
};
